import * as R from "ramda"

import {
	ArticleTemplate,
	ArticleTemplateFromPHP,
	Column,
	restrictColumn,
	sortByColumnAndPriority,
	toColumn
} from "../data";


const hydrateTemplate = (a: ArticleTemplateFromPHP): ArticleTemplate => {
	const column = toColumn(a.column)

	return {
		id: a.id.toString(),
		title: a.title,
		column: column,
		priority: a.priority
	}
}

export const hydrateTemplateWithRestrictedColumn = (lastColumn: Column): (articleTemplates: ArticleTemplateFromPHP) => ArticleTemplate => R.pipe(hydrateTemplate, restrictColumn(lastColumn))

export const templatesFromPHPTemplates = (articleTemplates: ArticleTemplateFromPHP[], lastColumn: Column): ArticleTemplate[] => {
	return articleTemplates
		.map(hydrateTemplateWithRestrictedColumn(lastColumn))
		.sort(sortByColumnAndPriority)
}



// WEBPACK FOOTER //
// ./src/communications/article-templates/read-only/data.ts